import React, { useEffect, useState } from 'react';

import { format, isValid } from 'date-fns';

import { Locale } from '../../../assets/Locale';

import "./Clock.scss";

export const Clock = (props)=>{
    const { className, value, children, prefix, suffix, opt, trait, ...passProps } = props;
    const say = Locale.use();

    const clock = say.duration(value, opt);
   
    return (
        <span className={["Clock", className]} {...passProps}>
            {trait ? trait(clock) : clock}
        </span>
    )
}